import { useMemo } from 'react';
import ForgotPasswordPage from 'Components/auth/ForgotPassword';
import InsuletConnectionPage from 'Components/auth/InsuletConnection';
import LoginPage from 'Components/auth/Login';
import ResetPasswordPage from 'Components/auth/ResetPassword';
import Document from 'Components/consents/Document';
import HipaaConsent from 'Components/consents/HipaaConsent';
import RWEConsent from 'Components/consents/RWEConsent';
import RegisterPage from 'Components/register/CreateNewUser';
import VerifyNumber from 'Components/register/VerifyNumber';
import AuthErrorPage from 'Components/utility/AuthErrorPage';
import InitializationErrorPage from 'Components/utility/InitializationErrorPage';
import { getStandaloneReturnUrl } from 'Utilities/standaloneFlow';
const routes = [{
  route: 'login',
  component: LoginPage
}, {
  route: 'connection',
  component: InsuletConnectionPage
}, {
  route: 'forgot-password',
  component: ForgotPasswordPage
}, {
  route: 'reset-password',
  component: ResetPasswordPage
}, {
  route: 'create-account',
  component: RegisterPage
}, {
  route: 'verify-number',
  component: VerifyNumber
}, {
  route: 'hipaa',
  component: HipaaConsent
}, {
  route: 'rwe',
  component: RWEConsent
}, {
  route: 'terms-of-use',
  component: Document,
  props: {
    type: 'toupat'
  }
}, {
  route: 'privacy-notice',
  component: Document,
  props: {
    type: 'privacypolicy'
  }
}, {
  route: 'auth-error',
  component: AuthErrorPage
}];
const useRouter = (location, initErrorStatus, initErrorCode, redirect_uri, data, standalone_return_uri, registration_return_uri) => {
  const {
    Component,
    props
  } = useMemo(() => {
    if (initErrorStatus) {
      return {
        Component: InitializationErrorPage,
        props: {
          errorStatus: initErrorStatus,
          errorCode: initErrorCode,
          redirect_uri
        }
      };
    }
    const lowerCaseLocation = location.toLowerCase();
    const route = routes.find(r => lowerCaseLocation.startsWith(`/${r.route.toLowerCase()}`));
    const Component = route?.component ?? LoginPage;
    const isStandalone = standalone_return_uri && (Component !== ResetPasswordPage || registration_return_uri);
    if (isStandalone) {
      const returnUrl = getStandaloneReturnUrl(standalone_return_uri);
      if (!returnUrl) {
        return {
          Component: AuthErrorPage
        };
      }
      if (Component === LoginPage) {
        return {
          Component: AuthErrorPage
        };
      }
    }
    return {
      Component,
      props: {
        ...route?.props,
        data
      }
    };
  }, [data, standalone_return_uri, registration_return_uri, initErrorCode, initErrorStatus, location, redirect_uri]);
  return {
    Component,
    props
  };
};
export default useRouter;